import React from 'react';
import styles from '../../assets/CommonScss/PopupWrapper.module.scss';

const PopupWrapper = ({ children, onClose }) => {
  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent}>
        {/* <span className={styles.closeIcon} onClick={onClose}>✕</span> */}
        {children}
      </div>
    </div>
  );
};

export default PopupWrapper;
